
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.955,"time":57300,"words":191}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Butler is represented by a tall dark blue meeple, and it is used to provide service for the most prestigious `}<a parentName="p" {...{
        "href": "/term/activity"
      }}>{`events`}</a>{` (such as music recitals or a grand ball). The Butler is also the hiring manager for new servants.`}</p>
    <div className="flavor-text">
      <p>{`The Butler in Victorian Britain was the senior domestic servant (along with the housekeeper), responsible for the smooth running of the house. In addition, he was in direct charge of the dining room, wine cellar, and pantry, as well as the male service staff and all country house activities. The Butler also wielded significant power as the ultimate arbiter of who was admitted to visit the family.`}</p>
    </div>
    <p>{`The Butler is required when new servants are hired or when a proposal is made to recruit a servant from another estate. After hiring/recruiting servants, he is placed in the “expended service” section of the player board along with the new members of the domestic staff for orientation. These meeples will then be rotated normally into available service. Like the `}<a parentName="p" {...{
        "href": "housekeeper"
      }}>{`housekeeper`}</a>{` and underbutler, he is a loyal servant who cannot be lured away with a recruiting action.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "title": "Butler"
}

